<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                    <h4 class="text-primary">Neraca (Trial Balance)</h4>
                    <div class="form-inline">
                        <div class="button-group">
                            <span><b>Company:</b> </span>
                            <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                              <option value="">-- All --</option>
                              <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="button-group ml-1">
                            <span class="mr-1"><b>Date:</b> </span>
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        </div>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row" style="margin-top: 200px;">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Aktiva</span></h5>
              <h3 class="my-3">
                <span>{{ totalAktiva | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-info">Total Pasiva</span></h5>
              <h3 class="my-3">
                <span>{{ totalKewajibanEkuitas | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Selisih</span></h5>
              <h3 class="my-3">
                <span>{{ totalAktiva - totalKewajibanEkuitas | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                      <ul class="nav nav-tabs nav-bordered">
                        <li class="nav-item"><a href="#neraca" data-toggle="tab" aria-expanded="false" class="nav-link active">Neraca</a></li>
                        <li class="nav-item"><a href="#akumulasi" data-toggle="tab" aria-expanded="false" class="nav-link">Akumulasi</a></li>
                        <li class="nav-item"><a href="#raw" data-toggle="tab" aria-expanded="false" class="nav-link">Neraca Lajur</a></li>
                        <li class="nav-item"><a href="#group" data-toggle="tab" aria-expanded="false" class="nav-link">Group</a></li>
                      </ul>
                      <div class="tab-content">
                        <div class="tab-pane active" id="neraca">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th style="background-color: black; color: white;">Daftar Akun</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Debit</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Credit</th>
                                  </thead>
                                  <tbody>
                                    <tr><td colspan="3"><b class="font-16">Asset</b></td></tr>
                                    <tr>
                                      <td colspan="3"><b class="ml-3 font-14">Kas & Bank</b></td>
                                    </tr>
                                    <tr v-for="d in kasBank" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Kas & Bank</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalKasBankRow | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalKasBank | currency }}</b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="3"><b class="ml-3 font-14">Piutang</b></td>
                                    </tr>
                                    <tr v-for="d in piutang" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Piutang</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalPiutangRow | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalPiutang | currency }}</b></td>
                                    </tr>
                                    <!-- Persediaan -->
                                    <tr>
                                      <td colspan="3"><b class="ml-3 font-14">Persediaan</b></td>
                                    </tr>
                                    <tr v-for="d in persediaan" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Persediaan</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalPersediaanRow | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalPersediaan | currency }}</b></td>
                                    </tr>
                                    <!-- Biaya dan Pajak -->
                                    <tr>
                                      <td colspan="3"><b class="ml-3 font-14">Biaya dan Pajak</b></td>
                                    </tr>
                                    <tr v-for="d in biayaPajak" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Biaya dan Pajak</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalBiayaPajakRow | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalBiayaPajak | currency }}</b></td>
                                    </tr>
                                    <!-- Asset Tetap -->
                                    <tr>
                                      <td colspan="3"><b class="ml-3 font-14">Asset Tetap</b></td>
                                    </tr>
                                    <tr v-for="d in assetTetap" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Asset Tetap</b></td>
                                      <td class="text-right"><b class="font-16">{{ totalAssetTetapRow | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalAssetTetap | currency }}</b></td>
                                    </tr>
                                    <!-- Total Aktiva -->
                                    <tr style="background-color: #1A1A2E; color: white;">
                                      <td><b class="font-16">Total Aktiva</b></td>
                                      <td></td>
                                      <td class="text-right"><b class="font-16">{{ totalAktiva | currency }}</b></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th style="background-color: black; color: white;">Daftar Akun</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Debit</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Credit</th>
                                  </thead>
                                  <tbody>
                                    <!-- Kewajiban -->
                                    <tr><td colspan="3"><b class="font-16">Kewajiban</b></td></tr>
                                    <tr v-for="d in kewajiban" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right"></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2"><b class="ml-3 font-14">Total Kewajiban Tetap</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalKewajiban | currency }}</b></td>
                                    </tr>
                                    <!-- Ekuitas -->
                                    <tr><td colspan="3"><b class="font-16">Ekuitas</b></td></tr>
                                    <tr v-for="d in ekuitas" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right"></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2"><b class="ml-3 font-14">Total Ekuitas</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalEkuitas | currency }}</b></td>
                                    </tr>
                                    <!-- Total Kewajiban & Ekuitas -->
                                    <tr style="background-color: #1A1A2E; color: white;">
                                      <td><b class="font-16">Total Pasiva</b></td>
                                      <td></td>
                                      <td class="text-right"><b class="font-16">{{ totalKewajibanEkuitas | currency }}</b></td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="akumulasi">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th style="background-color: black; color: white;">Daftar Akun</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Debit</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Credit</th>
                                  </thead>
                                  <tbody>
                                    <!-- KAS BANK -->
                                    <tr><td colspan="3"><b class="font-16">Asset</b></td></tr>
                                    <tr><td colspan="3"><b class="ml-3 font-14">Kas & Bank</b></td></tr>
                                    <tr v-for="d in groupKasBank" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Kas & Bank</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupKasBank | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14"></b></td>
                                    </tr>
                                    <!-- PIUTANG -->
                                    <tr><td colspan="3"><b class="ml-3 font-14">Piutang</b></td></tr>
                                    <tr v-for="d in groupPiutang" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Piutang</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupPiutang | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14"></b></td>
                                    </tr>
                                    <!-- Persediaan -->
                                    <tr><td colspan="3"><b class="ml-3 font-14">Persediaan</b></td></tr>
                                    <tr v-for="d in groupPersediaan" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Persediaan</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupPersediaan | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14"></b></td>
                                    </tr>
                                    <!-- Biaya dan Pajak -->
                                    <tr><td colspan="3"><b class="ml-3 font-14">Biaya dan Pajak</b></td></tr>
                                    <tr v-for="d in groupBiayaPajak" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Biaya dan Pajak</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupBiayaPajak | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14"></b></td>
                                    </tr>
                                    <!-- Asset Tetap -->
                                    <tr><td colspan="3"><b class="ml-3 font-14">Asset Tetap</b></td></tr>
                                    <tr v-for="d in groupAssetTetap" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                      <td class="text-right"></td>
                                    </tr>
                                    <tr>
                                      <td><b class="ml-3 font-14">Total Asset Tetap</b></td>
                                      <td class="text-right"><b class="font-16">{{ totalGroupAssetTetap | currency }}</b></td>
                                      <td class="text-right"><b class="ml-3 font-14"></b></td>
                                    </tr>
                                    <!-- Total Aktiva -->
                                    <tr style="background-color: #1A1A2E; color: white;">
                                      <td><b class="font-16">Total Aktiva</b></td>
                                      <td></td>
                                      <td class="text-right"><b class="font-16">{{ totalGroupAktiva | currency }}</b></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th style="background-color: black; color: white;">Daftar Akun</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Debit</th>
                                    <th class="text-center" style="background-color: #3d3d75; color: white;">Credit</th>
                                  </thead>
                                  <tbody>
                                    <!-- Kewajiban -->
                                    <tr><td colspan="3"><b class="font-16">Kewajiban</b></td></tr>
                                    <tr v-for="d in groupKewajiban" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span> </td>
                                      <td class="text-right"></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2"><b class="ml-3 font-14">Total Kewajiban Tetap</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupKewajiban | currency }}</b></td>
                                    </tr>
                                    <!-- Ekuitas -->
                                    <tr><td colspan="3"><b class="font-16">Ekuitas</b></td></tr>
                                    <tr v-for="d in groupEkuitas" :key="d.id">
                                      <td><span class="ml-5">{{ d.name }}</span> </td>
                                      <td class="text-right"></td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="2"><b class="ml-3 font-14">Total Ekuitas</b></td>
                                      <td class="text-right"><b class="ml-3 font-14">{{ totalGroupEkuitas | currency }}</b></td>
                                    </tr>
                                    <!-- Total Kewajiban & Ekuitas -->
                                    <tr style="background-color: #1A1A2E; color: white;">
                                      <td><b class="font-16">Total Pasiva</b></td>
                                      <td></td>
                                      <td class="text-right"><b class="font-16">{{ totalGroupPasiva | currency }}</b></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="raw">
                          <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                    <tr>
                                      <th style="background-color: black; color: white;">Daftar Akun</th>
                                      <th colspan="2" class="text-center" style="background-color: #1A1A2E; color: white">Saldo Awal</th>
                                      <th colspan="2" class="text-center" style="background-color: #3d3d75; color: white;">By Date</th>
                                      <th colspan="3" class="text-center" style="background-color: #6092a3; color: white;">Saldo Akhir</th>
                                    </tr>
                                    <tr>
                                      <th style="background-color: black; color: white;">&nbsp;</th>
                                      <th class="text-right" style="background-color: #1A1A2E; color: white">Debit</th>
                                      <th class="text-right" style="background-color: #1A1A2E; color: white">Credit</th>
                                      <th class="text-right" style="background-color: #3d3d75; color: white;">Debit</th>
                                      <th class="text-right" style="background-color: #3d3d75; color: white;">Credit</th>
                                      <th class="text-right" style="background-color: #6092a3; color: white;">Debit</th>
                                      <th class="text-right" style="background-color: #6092a3; color: white;">Credit</th>
                                      <th class="text-right" style="background-color: #6092a3; color: white;">Saldo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                      <td colspan="8"><b class="font-16">Asset</b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="ml-3">Kas & Bank</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalKasBank | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in kasBank" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="ml-3">Piutang</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalPiutang | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in piutang" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="ml-3">Persediaan</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalPersediaan | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in persediaan" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="ml-3">Biaya Pajak</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalBiayaPajak | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in biayaPajak" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="ml-3">Asset Tetap</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalAssetTetap | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in assetTetap" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr style="background-color: black; color: white;">
                                      <td colspan="7"><b class="ml-5 font-14">Total Aktiva</b></td>
                                      <td class="text-right"><b class=font-14>{{ totalAktiva | currency }}</b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="font-16">Kewajiban</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalKewajiban | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in kewajiban" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="7"><b class="font-16">Ekuitas</b></td>
                                      <td class="text-right"><b class="ml-3">{{ totalEkuitas | currency }}</b></td>
                                    </tr>
                                    <tr v-for="d in ekuitas" :key="d.id">
                                      <td><i class="ml-5">{{ d.code }}</i> {{ d.name }}</td>
                                      <td class="text-right">{{ d.saldo_debit | currency }}</td>
                                      <td class="text-right">{{ d.saldo_credit | currency }}</td>
                                      <td class="text-right">{{ d.debit | currency }}</td>
                                      <td class="text-right">{{ d.credit | currency }}</td>
                                      <td class="text-right">{{ d.total_debit | currency }}</td>
                                      <td class="text-right">{{ d.total_credit | currency }}</td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr style="background-color: black; color: white;">
                                      <td colspan="7"><b class="ml-5 font-14">Total Pasiva</b></td>
                                      <td class="text-right"><b class=font-14>{{ totalKewajibanEkuitas | currency }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="tab-pane" id="group">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                    <thead>
                                      <tr>
                                        <th style="background-color: black; color: white;">Akun</th>
                                        <th class="text-right" style="background-color: #6092a3; color: white;">Debit</th>
                                        <th class="text-right" style="background-color: #6092a3; color: white;">Credit</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                          <td colspan="3"><b class="font-16">Asset</b></td>
                                        </tr>
                                        <tr>
                                          <td><b class="ml-3">Kas & Bank</b></td>
                                          <td class="text-right">{{ totalKasBank | currency }}</td>
                                          <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                          <td><b class="ml-3">Piutang</b></td>
                                          <td class="text-right">{{ totalPiutang | currency }}</td>
                                          <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                          <td><b class="ml-3">Persediaan</b></td>
                                          <td class="text-right">{{ totalPersediaan | currency }}</td>
                                          <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                          <td><b class="ml-3">Biaya Pajak</b></td>
                                          <td class="text-right">{{ totalBiayaPajak | currency }}</td>
                                          <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                          <td><b class="ml-3">Asset Tetap</b></td>
                                          <td class="text-right">{{ totalAssetTetap | currency }}</td>
                                          <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                          <td><b class="font-16">Kewajiban</b></td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{ totalKewajiban | currency }}</td>
                                        </tr>
                                        <tr>
                                          <td><b class="font-16">Ekuitas</b></td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{ totalEkuitas | currency }}</td>
                                        </tr>
                                        <tr style="background-color: black; color: white;">
                                          <td>
                                            <b class="ml-5 font-14">Total</b>
                                          </td>
                                          <td class="text-right">
                                            <b class=font-14>{{ (totalKasBank + totalPiutang + totalPersediaan + totalBiayaPajak) - totalAssetTetap  | currency }}</b>
                                          </td>
                                          <td class="text-right">
                                            <b class=font-14>{{ totalKewajiban + totalEkuitas | currency }}</b>
                                          </td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-md-4"><pre>{{ kasBank }}</pre></div>
        <div class="col-md-4"><pre>{{ groupKasBank }}</pre></div>
      </div> -->
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, report2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'NeracaDetail',
  components: {
    Loading,
    DatePicker
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    }),
    groupKasBank () {
      var result = []
      this.kasBank.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupKasBank () {
      const array = this.groupKasBank
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    groupPiutang () {
      var result = []
      this.piutang.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupPiutang () {
      const array = this.groupPiutang
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    groupPersediaan () {
      var result = []
      this.persediaan.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupPersediaan () {
      const array = this.groupPersediaan
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    groupBiayaPajak () {
      var result = []
      this.biayaPajak.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupBiayaPajak () {
      const array = this.groupBiayaPajak
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    groupAssetTetap () {
      var result = []
      this.assetTetap.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupAssetTetap () {
      const array = this.groupAssetTetap
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalGroupAktiva () {
      var sum = 0
      sum = this.totalGroupKasBank + this.totalGroupPiutang + this.totalGroupPersediaan + this.totalGroupBiayaPajak + this.totalGroupAssetTetap
      return sum
    },
    groupKewajiban () {
      var result = []
      this.kewajiban.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupKewajiban () {
      const array = this.groupKewajiban
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    groupEkuitas () {
      var result = []
      this.ekuitas.reduce(function (res, value) {
        if (!res[value.name]) {
          res[value.name] = {
            name: value.name,
            code: value.code,
            total: value.total
          }
          result.push(res[value.name])
        } else {
          res[value.name].total = parseFloat(res[value.name].total) + parseFloat(value.total)
        }
        return res
      }, {})
      return result
    },
    totalGroupEkuitas () {
      const array = this.groupEkuitas
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalGroupPasiva () {
      var sum = 0
      sum = this.totalGroupKewajiban + this.totalGroupEkuitas
      return sum
    },
    totalKasBankRow () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === 'kas-bank') {
          var amount = parseFloat(array[i].total)
          if (amount < 0) {
            sum -= amount
          } else {
            sum += amount
          }
        }
      }
      return sum
    },
    totalPiutangRow () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === 'piutang') {
          var amount = parseFloat(array[i].total)
          if (amount < 0) {
            sum -= amount
          } else {
            sum += amount
          }
        }
      }
      return sum
    },
    totalPersediaanRow () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === 'persediaan') {
          var data = array[i].data
          for (let a = 0; a < data.length; a++) {
            var amount = data[a].total
            if (amount < 0) {
              console.log('minus: ' + amount)
              sum -= Math.abs(amount)
            } else {
              sum += amount
            }
          }
        }
      }
      return sum
    },
    totalBiayaPajakRow () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === 'biaya-pajak') {
          var data = array[i].data
          for (let a = 0; a < data.length; a++) {
            var amount = data[a].total
            if (amount < 0) {
              console.log('minus: ' + amount)
              sum -= Math.abs(amount)
            } else {
              sum += amount
            }
          }
        }
      }
      return sum
    },
    totalAssetTetapRow () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].name === 'asset-tetap') {
          var data = array[i].data
          for (let a = 0; a < data.length; a++) {
            var amount = parseFloat(data[a].total)
            console.log('asset tetap: ' + amount)
            if (amount < 0) {
              console.log('minus: ' + amount)
              sum -= Math.abs(amount)
            } else {
              sum += amount
            }
          }
        }
      }
      return sum
    },
    totalAktiva () {
      var sum = 0
      sum = this.totalKasBank + this.totalPiutang + this.totalPersediaan + this.totalBiayaPajak + this.totalAssetTetap
      return sum
    },
    totalKewajibanEkuitas () {
      var sum = 0
      sum = this.totalKewajiban + this.totalEkuitas
      return sum
    },
    totalNeraca () {
      var sum = 0
      sum = Math.round(this.totalAktiva - (this.totalKewajibanEkuitas))
      return sum
    },
    companyData () {
      var obj = {
        name: null,
        address: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address
        }
      }
      return obj
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    if (window.localStorage.getItem('authUser')) {
      const authU = window.localStorage.getItem('authUser')
      const auth = JSON.parse(authU)
      console.log('auth session')
      console.log(auth)
      this.company_no = auth.user.company_no
    }
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      dataRaw: [],
      kasBank: [],
      totalKasBank: '0',
      totalDebitKasBank: '0',
      totalCreditKasBank: '0',
      piutang: [],
      totalPiutang: '0',
      totalDebitPiutang: '0',
      totalCreditPiutang: '0',
      persediaan: [],
      totalPersediaan: '0',
      totalDebitPersediaan: '0',
      totalCreditPersediaan: '0',
      biayaPajak: [],
      totalBiayaPajak: '0',
      totalDebitBiayaPajak: '0',
      totalCreditBiayaPajak: '0',
      assetTetap: [],
      totalAssetTetap: '0',
      totalDebitAssetTetap: '0',
      totalCreditAssetTetap: '0',
      kewajiban: [],
      totalKewajiban: '0',
      totalDebitKewajiban: '0',
      totalCreditKewajiban: '0',
      ekuitas: [],
      totalEkuitas: '0',
      totalDebitEkuitas: '0',
      totalCreditEkuitas: '0',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company_no: '',
      startDate: [date1, date2],
      begin: new Date(),
      end: new Date(),
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      totalLabaRugi: null,
      account: [{
        id: null,
        hierarcy: null,
        parent_code: null,
        code: null,
        name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        total: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    editJournal: function (id) {
      alert(id)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[1].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      var url = financeUrl + '/neraca-simple-detail'
      console.log(url)
      Axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            if (array[i].name === 'kas-bank') {
              this.kasBank = array[i].data
              this.totalKasBank = array[i].total
              this.totalDebitKasBank = array[i].total_debit
              this.totalCreditKasBank = array[i].total_credit
            } else if (array[i].name === 'piutang') {
              this.piutang = array[i].data
              this.totalPiutang = array[i].total
              this.totalDebitPiutang = array[i].total_debit
              this.totalCreditPiutang = array[i].total_credit
            } else if (array[i].name === 'persediaan') {
              this.persediaan = array[i].data
              this.totalPersediaan = array[i].total
              this.totalDebitPersediaan = array[i].total_debit
              this.totalCreditPersediaan = array[i].total_credit
            } else if (array[i].name === 'biaya-pajak') {
              this.biayaPajak = array[i].data
              this.totalBiayaPajak = array[i].total
              this.totalDebitBiayaPajak = array[i].total_debit
              this.totalCreditBiayaPajak = array[i].total_credit
            } else if (array[i].name === 'asset-tetap') {
              this.assetTetap = array[i].data
              this.totalAssetTetap = array[i].total
              this.totalDebitAssetTetap = array[i].total_debit
              this.totalCreditAssetTetap = array[i].total_credit
            } else if (array[i].name === 'kewajiban') {
              this.kewajiban = array[i].data
              this.totalKewajiban = array[i].total
              this.totalDebitKewajiban = array[i].total_debit
              this.totalCreditKewajiban = array[i].total_credit
            } else if (array[i].name === 'ekuitas') {
              this.ekuitas = array[i].data
              this.totalEkuitas = array[i].total
              this.totalDebitEkuitas = array[i].total_debit
              this.totalCreditEkuitas = array[i].total_credit
            }
          }
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: [{
          kasBank: this.kasBank,
          piutang: this.piutang,
          persediaan: this.persediaan,
          biayaPajak: this.biayaPajak,
          assetTetap: this.assetTetap,
          kewajiban: this.kewajiban,
          ekuitas: this.ekuitas
        }],
        totalKasBank: this.totalKasBank,
        totalPiutang: this.totalPiutang,
        totalPersediaan: this.totalPersediaan,
        totalBiayaPajak: this.totalBiayaPajak,
        totalAssetTetap: this.totalAssetTetap,
        totalAktiva: this.totalAktiva,
        totalKewajiban: this.totalKewajiban,
        totalEkuitas: this.totalEkuitas,
        totalKewajibanEkuitas: this.totalKewajibanEkuitas
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await Axios.post(report2Url + '/neraca', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
  .first-col {
    position: absolute;
    width: 5em;
    margin-left: -5em;
  }
</style>
